import { Record } from 'immutable';
import create from './create';

const StudentTotalPointRecord = Record({
  studentId: undefined,
  totalPoint: undefined,
});

class StudentTotalPoint extends StudentTotalPointRecord { }
StudentTotalPoint.create = create;

export default StudentTotalPoint;



// WEBPACK FOOTER //
// ./data/OnlineHomework/TotalPoint/model.js